var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.project === _vm.PROJECTS.INTELLI_CONTROL_TOWER)?_c('ControlTowerDashboard'):_c('CrossDockDashboard')
}
var staticRenderFns = []

export { render, staticRenderFns }